import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './assets/scss/styles.scss';
import './assets/scss/dev.scss'
import { Suspense, lazy } from "react";
import "./pages/appPages/wallet/config/index"; // ⬅️ IMPORTANT: this runs createAppKit()


// Auth pages
const Home = lazy(() => import("./pages/home/Home"));
const Login = lazy(() => import("./pages/auth/Login"));
const Signup = lazy(() => import("./pages/auth/Signup"));
const OTPVerifyPage = lazy(() => import("./pages/auth/OTPVerify"));
const ForgotPassword = lazy(() => import("./pages/auth/Forgotpassword"));
const ResetPassword = lazy(() => import("./pages/auth/ResetPassword"));

// Layout
const AppLayout = lazy(() => import("./layout/appLayout/appLayout"));

// App pages
const Dashboard = lazy(() => import("./pages/appPages/dashboard"));
const Profile = lazy(() => import("./pages/appPages/profile/profile"));
const Deposit = lazy(() => import("./pages/appPages/deposit"));
const Withdraw = lazy(() => import("./pages/appPages/withdraw"));
const Wallet = lazy(() => import("./pages/appPages/wallet"));
const Asset = lazy(() => import("./pages/appPages/asset"));
const Invesmentplan = lazy(() => import("./pages/appPages/investmentplan"));
const MyReferrals = lazy(() => import("./pages/appPages/my-referrals"));
const History = lazy(() => import("./pages/appPages/history/history"));
const SupportTicket = lazy(() => import("./pages/appPages/supportticket/supportTicket"));

// Static pages
const Termsconditions = lazy(() => import("./pages/terms"));
const PrivacyPolicy = lazy(() => import("./pages/privacy"));
const AboutUS = lazy(() => import("./pages/About"));
const FaqPage = lazy(() => import("./component/faq/faq"));
const PageNotFound = lazy(() => import("./pages/pagenotfound"));

// Home cards
const HomeCard1 = lazy(() => import("./pages/home/Homecard1"));
const HomeCard2 = lazy(() => import("./pages/home/Homecard2"));
const HomeCard3 = lazy(() => import("./pages/home/Homecard3"));
const HomeCard4 = lazy(() => import("./pages/home/Homecard4"));
const HomeCard5 = lazy(() => import("./pages/home/Homecard5"));
const HomeCard6 = lazy(() => import("./pages/home/Homecard6"));


const AuthRoute = lazy(()=>import('./Redux/PrivateRouter/Authprotect'));
const PrivateRoute = lazy(()=>import("./Redux/PrivateRouter"));
const ScrollToTop = lazy(()=>import('./helpers/scrooltp'));


const Pageloader =lazy(()=>import('./helpers/loader/Pageloader'));



function App() {
  return (
    <Router>
      <ScrollToTop/>
  <Suspense fallback={<Pageloader />}>
    <Routes>
      <Route index path="/" element={<Home />} />
      {/* Auth protected routes (only for non-logged-in users) */}
      <Route element={<AuthRoute />}>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/signup/:referralCode" element={<Signup />} />
        <Route path="/otpverify" element={<OTPVerifyPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Route>

      {/* Private routes with layout */}
      <Route
        element={
          <PrivateRoute>
            <AppLayout />
          </PrivateRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/asset" element={<Asset />} />
        <Route path="/my-profile" element={<Profile />} />
        <Route path="/investment-plan" element={<Invesmentplan />} />
        <Route path="/deposit" element={<Deposit />} />
        <Route path="/withdraw" element={<Withdraw />} />
        <Route path="/my-referral" element={<MyReferrals />} />
        <Route path="/history" element={<History />} />
        <Route path="/support-ticket" element={<SupportTicket />} />
        <Route path="/wallet" element={<Wallet />} />
      </Route>

      {/* Public pages */}
      <Route path="/terms" element={<Termsconditions />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/aboutus" element={<AboutUS />} />

      <Route path="/home1" element={<HomeCard1 />} />
      <Route path="/home2" element={<HomeCard2 />} />
      <Route path="/home3" element={<HomeCard3 />} />
      <Route path="/home4" element={<HomeCard4 />} />
      <Route path="/home5" element={<HomeCard5 />} />
      <Route path="/home6" element={<HomeCard6 />} />

      {/* 404 */}
      <Route path="*" element={<PageNotFound />} />

    </Routes>
  </Suspense>
</Router>
  );
}

export default App;
